"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProfileShiftMatchesDto = instanceOfProfileShiftMatchesDto;
exports.ProfileShiftMatchesDtoFromJSON = ProfileShiftMatchesDtoFromJSON;
exports.ProfileShiftMatchesDtoFromJSONTyped = ProfileShiftMatchesDtoFromJSONTyped;
exports.ProfileShiftMatchesDtoToJSON = ProfileShiftMatchesDtoToJSON;
exports.ProfileShiftMatchesDtoToJSONTyped = ProfileShiftMatchesDtoToJSONTyped;
const ShiftDto_1 = require("./ShiftDto");
/**
 * Check if a given object implements the ProfileShiftMatchesDto interface.
 */
function instanceOfProfileShiftMatchesDto(value) {
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('shifts' in value) || value['shifts'] === undefined)
        return false;
    return true;
}
function ProfileShiftMatchesDtoFromJSON(json) {
    return ProfileShiftMatchesDtoFromJSONTyped(json, false);
}
function ProfileShiftMatchesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseProfileId': json['nurseProfileId'],
        'shifts': (json['shifts'].map(ShiftDto_1.ShiftDtoFromJSON)),
    };
}
function ProfileShiftMatchesDtoToJSON(json) {
    return ProfileShiftMatchesDtoToJSONTyped(json, false);
}
function ProfileShiftMatchesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseProfileId': value['nurseProfileId'],
        'shifts': (value['shifts'].map(ShiftDto_1.ShiftDtoToJSON)),
    };
}
//# sourceMappingURL=ProfileShiftMatchesDto.js.map